import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

import { BasicButton } from "components/buttons/basic-button";

import {
  AssistantActionButtonProps,
  IAssistantHighlightStyleProps,
} from "./types";

export const AssistantActionButton = styled(
  BasicButton
)<AssistantActionButtonProps>(({ theme }) => ({
  ...theme.typography.subtitle6,
  color: theme.palette.primary.main,
  height: theme.spacing(7),
  minWidth: 0,
  padding: theme.spacing(2, 6),
  boxShadow: "none",
  "&:hover": { boxShadow: "none" },
  "&.MuiButton-outlined": {
    borderColor: theme.palette.custom.semantic.border.default,
  },
}));

export const AssistantBody = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
  overflowWrap: "anywhere",
  padding: theme.spacing(5),
  gap: theme.spacing(4),
}));

export const AssistantMutedText = styled(Typography)(({ theme }) => ({
  display: "block",
  color: theme.palette.custom.semantic.text.muted,
}));

export const AssistantHighlight = styled(Box, {
  shouldForwardProp: (prop) => prop !== "contrastRing",
})<IAssistantHighlightStyleProps>(({ theme, contrastRing }) => ({
  position: "fixed",
  pointerEvents: "none",
  border: `3px solid ${
    contrastRing ? theme.palette.primary.main : theme.palette.secondary.main
  }`,
  boxShadow: contrastRing
    ? `inset 0 0 0 ${theme.spacing(1)} ${theme.palette.custom.white}`
    : "none",
  boxSizing: "border-box",
  borderRadius: theme.shape.borderRadius[1],
  zIndex: theme.zIndex.modal + 1,
}));
